import { orchestrator } from 'satcheljs';
import getQuery from '../selectors/getQuery';
import { showFullOptions } from 'owa-options-orchestration';
import { logUsage } from 'owa-analytics';
import resetSearch from '../actions/resetSearch';

export const OPTION_NAVIGATION_KEY = 'OptionDirectNavigationv2';

export default orchestrator(showFullOptions, ({ option }) => {
    if (option) {
        // The option value is only set if the user navigated to a specific option,
        // rather than just opening the full options from the link at the bottom of the flex pane.
        // We should log the option chosen, as well as the current search term
        logUsage(OPTION_NAVIGATION_KEY, {
            optionKey: option,
            query: getQuery(),
        });
    }

    resetSearch(!!option /** Successful search **/);
});
